// src/components/utiles/excel.js
import * as XLSX from "xlsx";

export function exportRowsToExcel({ rows, filename, columns }) {
  // columns: [{ header: "Título", value: (row)=>... }]
  const data = [columns.map((c) => c.header)];
  for (const r of rows) data.push(columns.map((c) => c.value(r)));
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(data);
  XLSX.utils.book_append_sheet(wb, ws, "Datos");
  XLSX.writeFile(wb, filename);
}
